export const styles = () => `.p-select-overlay {
overflow: hidden;
}

.p-overlay .p-autocomplete-list-container li.p-autocomplete-option div{
 font-weight: 400;
}

.p-select-dropdown-icon {
  padding: 0;
}
`;
